import { updateStatuses } from '../statuses';

/**
 * This handles storing update status and time in a common format, allowing the UI to render differently while waiting for data.
 * The passed reducer factory will only need to deal with successful requests.
 * It should either return a reducer for inititalState.value, or null if it can't handle the action type
 */
export function updateableReducer(reducerFactory, initialState) {
    return (state = initialState, updateAction) => {
        const reducer = reducerFactory(updateAction.type, updateAction);
        if (!reducer) { return state; }

        const value = updateAction.updateStatus === updateStatuses.success ?
            reducer(state.value, updateAction.value) :
            state.value;

        const valueUpdateTime = updateAction.updateStatus === updateStatuses.success ?
            updateAction.statusUpdateTime :
            state.valueUpdateTime;

        // HACK - since we don't have proper pagination and only fetches set totalCount, avoid setting it to undefined
        // when we get other kinds of actions
        const totalCount = updateAction.totalCount ? updateAction.totalCount : state.totalCount;

        return { 
            ...state,
            value,
            currentError: updateAction.error,
            valueUpdateTime: valueUpdateTime,
            statusUpdateTime: updateAction.statusUpdateTime,
            totalCount: totalCount,
            updateStatus: updateAction.updateStatus
        };
    };
};

export function newMapWith(oldMap, newId, newValue) {
    return new Map([...oldMap, [newId, newValue]]);
}

export const replaceInMap = (map, id, newValue) => {
    const newMap = new Map([...map]);
    newMap.delete(id);
    newMap.set(id, newValue);
    
    return newMap;
};



// WEBPACK FOOTER //
// ./src/js/reducers/common.js